<template>
  <td>
    HMS :
  </td>
  <td>
    {{ config?.HMS?.errorHMS?.length }} {{ $e("erreur(s)")}}
  </td>
  <td>
    <div v-html="config?.HMS?.errorHMS?.length > 0
      ? cheack.warning
      : cheack.ok
      "></div>
  </td>
</template>
<script>
export default {
  props: {
    config: Object,
    cheack: Object
  },

  computed: {

  },
};
</script>
